import { Box, Typography, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { DashboardPages } from "../../../constant/ApplicationJson";
import { font } from "../../../styles/font";
import { GroupsOutlined } from "@mui/icons-material";
import { useApplicationContext } from "../../../context/ApplicationContext";
import { Settings_Module } from "../../../constant/ApplicationVariables";
import ActiveProjectCard from "./ActiveProjectCard";
import { DashboardCustomIcon } from "../../styled/CustomIcons";
import {
  AdminPanelSettingsOutlined,
  HistoryOutlined,
  PeopleOutlined,
  PersonOutlined,
  SecurityOutlined,
  VpnKeyOutlined,
} from "@mui/icons-material";

const Local_Modules = {
  dashboard: Settings_Module.dashboard,
  license: Settings_Module.license,
  roleManagement: Settings_Module.roleManagement,
  userManagement: Settings_Module.userManagement,
  profile: Settings_Module.profile,
  activityLog: Settings_Module.activityLog,
  permissions: Settings_Module.permissions,
  teams: Settings_Module.teams,
};

export default function SettingsSidebar() {
  const theme = useTheme();
  const { activeSettingsModule, setActiveSettingsModule } =
    useApplicationContext();

  let list = [
    {
      label: Local_Modules.profile,
      value: Local_Modules.profile,
      icon: <PersonOutlined />,
    },
    {
      label: Local_Modules.dashboard,
      value: Local_Modules.dashboard,
      icon: <DashboardCustomIcon />,
    },
    {
      label: Local_Modules.license,
      value: Local_Modules.license,
      icon: <VpnKeyOutlined />,
    },
    {
      label: Local_Modules.roleManagement,
      value: Local_Modules.roleManagement,
      icon: <AdminPanelSettingsOutlined />,
    },
    {
      label: Local_Modules.userManagement,
      value: Local_Modules.userManagement,
      icon: <PeopleOutlined />,
    },

    {
      label: Local_Modules.activityLog,
      value: Local_Modules.activityLog,
      icon: <HistoryOutlined />,
    },
    {
      label: Local_Modules.permissions,
      value: Local_Modules.permissions,
      icon: <SecurityOutlined />,
    },
    {
      label: Local_Modules.teams,
      value: Local_Modules.teams,
      icon: <GroupsOutlined />,
    },
  ];

  const handleClick = (item) => {
    setActiveSettingsModule(item);
  };

  useEffect(() => {
    setActiveSettingsModule(Local_Modules.profile);
  }, []);

  return (
    <Box className="flex flex-col gap-2 px-4 py-4 flex-1 overflow-y-auto">
      {list?.map((item, index) => {
        const isActive = activeSettingsModule === item?.value;
        return (
          <Box
            key={index}
            onClick={() => handleClick(item?.value)}
            className="flex items-center gap-2 px-2 py-1 cursor-pointer rounded-md"
            sx={{
              backgroundColor: isActive
                ? "hsl(var(--primary) / 0.12)" // Light background for active
                : "transparent",
              color: isActive
                ? "hsl(var(--primary))" // Primary color for active text
                : "hsl(var(--foreground))", // Dark/foreground color for inactive
              transition: "all 0.2s ease",
              position: "relative",
              "&::before": isActive ? {
                content: '""',
                position: "absolute",
                left: 0,
                top: "20%",
                height: "60%",
                width: "3px",
                backgroundColor: "hsl(var(--primary))", // Dark primary indicator bar
                borderRadius: "0 2px 2px 0",
              } : {},
              "&:hover": {
                backgroundColor: isActive 
                  ? "hsl(var(--primary) / 0.12)" 
                  : "hsl(var(--primary) / 0.06)", // Very light hover
              },
            }}
          >
            <Box
              className="flex items-center justify-center w-6"
              sx={{ 
                fontSize: font.size.fs_5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& svg": {
                  color: isActive 
                    ? "hsl(var(--primary))" // Primary color for active icon
                    : "hsl(var(--foreground))", // Dark/foreground color for inactive icons
                  fontSize: "1.25rem",
                }
              }}
            >
              {item?.icon}
            </Box>
            <Typography
              className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap box-border"
              fontWeight={isActive ? 600 : 400}
              sx={{ 
                color: isActive 
                  ? "hsl(var(--primary))" // Primary color for active text
                  : "hsl(var(--foreground))" // Dark/foreground color for inactive text
              }}
            >
              {item?.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}